import { commonViewTexts } from '../common';
import { createDialogCommonViewTexts } from './create-dialog-common';

const targetName = commonViewTexts.model;

export const createNewModelDialogViewTexts = {
  title: `${targetName} 新規登録`,
  descriptions: createDialogCommonViewTexts.messageGenerator(targetName),
  labels: {
    registerer: commonViewTexts.registerer,
    modelName: `${targetName}名`
  }
} as const;
